const HOSTNAME_WITH_TLD = /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i;

function parseWebsite(input: string | null | undefined): URL | null {
  const trimmed = input?.trim() ?? '';
  if (!trimmed || /\s/.test(trimmed)) return null;

  const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

  try {
    const url = new URL(withScheme);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    if (!HOSTNAME_WITH_TLD.test(url.hostname)) return null;
    return url;
  } catch {
    return null;
  }
}

/**
 * The website a brand typed, as the address the Brand DNA reads: `https://` is
 * added when the brand typed a bare domain, a trailing slash on the root is
 * dropped. Null when no browser could open it.
 */
export function normalizeWebsiteUrl(input: string | null | undefined): string | null {
  const url = parseWebsite(input);
  if (!url) return null;

  const path = url.pathname === '/' ? '' : url.pathname.replace(/\/$/, '');
  return `${url.protocol}//${url.host}${path}`;
}

/** The domain shown for a website: no scheme, no `www.`. */
export function websiteDomain(input: string | null | undefined): string | null {
  const url = parseWebsite(input);
  return url ? url.hostname.replace(/^www\./i, '') : null;
}
